import React, { Component } from 'react';
import { message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';

import { queryDeleteCustom } from '@api/crm/custom';
import { queryOrgCompanyList } from '@api/core/org';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageSize: 10,
      nowPage: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getOrganiztion();
  }

  getOrganiztion = (pageNo, pageSize) => {
    const context = this;
    const params = {};
    params.type = 1;
    params.pageNo = pageNo || 1;
    params.pageSize = pageSize || 10;
    queryOrgCompanyList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data.result,
          pageSize: res.data.pageSize,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  deleteCustom = uuid => {
    const context = this;
    const { nowPage, pageSize } = this.state;
    queryDeleteCustom(uuid).then(res => {
      if (res.statusCode === 200) {
        message.success('删除成功');
        context.getCustomCompany(nowPage, pageSize);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '公司名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => <Link>{record.name}</Link>,
      },
      {
        title: '客户列表',
        dataIndex: 'custom',
        key: 'custom',
        render: (text, record) => (
          <Link to={`/custom/company/${record.uuid}/custom`}>客户列表</Link>
        ),
      },
      {
        title: '资金列表',
        dataIndex: 'bill',
        key: 'bill',
        render: (text, record) => <Link to={`/custom/company/${record.uuid}/bill`}>资金列表</Link>,
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            <Link to={`/custom/company/${record.uuid}/custom`}>客户关联</Link>
            <span className="ant-divider" />
            <Popconfirm
              onConfirm={() => this.deleteCustom(record.uuid)}
              title="确定删除当前组织吗？"
              placement="topRight"
              overlayStyle={{ width: 200 }}
            >
              <a className="ant-dropdown-link">删除</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
  };

  render() {
    const { data } = this.state;
    const { pageSize, total } = this.state;
    const pagination = {
      total,
      showSizeChanger: true,
      pageSize,
      onShowSizeChange: (current, size) => {
        this.getOrganiztion(current, size);
      },
      onChange: current => {
        this.getOrganiztion(current, pageSize);
      },
    };

    return (
      <div>
        <Table
          rowKey="uuid"
          style={{ background: '#fff' }}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/custom/company/Index.js